module.exports = __webpack_public_path__ + "static/media/add_order_button_grey.46f7bab1.svg";